import sponsorsAPI from "../api/sponsorsAPI";

const state = {
  sponsorsGroup: [],
  isFetching: false,
  hasFetchedSponsors: false,
};

const actions = {
  async fetchSponsors({commit}, {id}) {
    commit("updateIsFetching", true);

    try {
      const response = await sponsorsAPI.fetch(id);
      commit("updateSponsors", response);
    } catch (error) {
      console.error('Failed to fetch notification:', error);
    } finally {
      commit("updateIsFetching", false);
    }
  }
};

const mutations = {
  updateSponsors(state, payload) {
    state.sponsorsGroup = [
      ...payload.data.data,
    ];
    state.hasFetchedSponsors = true;
  },

  updateIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },
};

const getters = {
  sponsorsGroup(state) {
    return state.sponsorsGroup;
  },

  isFetching(state) {
    return state.isFetching;
  },

  hasFetchedSponsors(state) {
    return state.hasFetchedSponsors;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
